



















































































































































































































































































































































































































































































import Vue from 'vue';
import draggable from 'vuedraggable';
import html2canvas from 'html2canvas';
import AirStatusResultBar from '@/components/result/AirStatusResultBar.vue';
import AirbaseTarget from '@/components/airbase/AirbaseTarget.vue';
import AirbaseComp from '@/components/airbase/Airbase.vue';
import ItemList from '@/components/item/ItemList.vue';
import ItemPresetComponent from '@/components/item/ItemPreset.vue';
import AirbaseInfo from '@/classes/airbase/airbaseInfo';
import Airbase, { AirbaseBuilder } from '@/classes/airbase/airbase';
import Const, { AB_MODE, CELL_TYPE } from '@/classes/const';
import Item, { ItemBuilder } from '@/classes/item/item';
import BattleInfo from '@/classes/enemy/battleInfo';
import SiteSetting from '@/classes/siteSetting';
import ItemPreset from '@/classes/item/itemPreset';
import ItemMaster from '@/classes/item/itemMaster';
import Convert from '@/classes/convert';

export default Vue.extend({
  name: 'AirbaseAll',
  components: {
    AirbaseComp,
    ItemList,
    draggable,
    AirStatusResultBar,
    AirbaseTarget,
    ItemPresetComponent,
  },
  props: {
    value: {
      type: AirbaseInfo,
      required: true,
    },
    battleInfo: {
      type: BattleInfo,
      required: true,
    },
    handleMinimize: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    itemListDialog: false,
    targetDialog: false,
    difficultyLevelItem: Const.DIFFICULTY_LEVELS,
    dialogTarget: [-1, -1],
    tab: 0,
    itemDialogWidth: 1200,
    capturing: false,
    bulkUpdateDialog: false,
    bulkUpdateSlotValue: 18,
    bulkUpdateSlotChanged: false,
    bulkUpdateTarget: [1, 1, 1],
    itemPresetDialog: false,
    tempAirbase: undefined as undefined | Airbase,
  }),
  computed: {
    airbaseInfo(): AirbaseInfo {
      return this.value;
    },
    unMatchModes(): boolean[] {
      const modes = this.airbaseInfo.airbases.map((v) => v.mode);
      if (this.airbaseInfo.isDefense) {
        return modes.map((v) => v !== AB_MODE.DEFENSE);
      }

      return modes.map((v) => v !== AB_MODE.BATTLE);
    },
    existsBattleAirbase(): boolean {
      return this.airbaseInfo.airbases.some((v) => v.mode === AB_MODE.BATTLE);
    },
    rangeError(): string {
      const errors: string[] = [];
      const { airbases } = this.value;
      for (let i = 0; i < airbases.length; i += 1) {
        const airbase = airbases[i];
        if (airbase.mode !== AB_MODE.BATTLE || !airbase.items.some((v) => v.data.id > 0)) {
          continue;
        }

        const [cell1, cell2] = airbase.battleTarget.map((v) => this.battleInfo.fleets[v]);
        if (cell1 && airbase.range < cell1.range) {
          // 6-4基地半径緩和チェック
          if (cell1.area !== 64 || cell1.nodeName !== 'N' || !airbase.hasJet) {
            errors.push(`Land Base ${i + 1}`);
          }
        } else if (cell2 && airbase.range < cell2.range) {
          // 6-4基地半径緩和チェック
          if (cell2.area !== 64 || cell2.nodeName !== 'N' || !airbase.hasJet) {
            errors.push(`Land Base ${i + 1}`);
          }
        }
      }
      return errors.length ? `${errors.join(', ')}: Insufficient range` : '';
    },
    isBulkUpdateTargetAll(): boolean {
      return !this.bulkUpdateTarget.some((v) => !v);
    },
    isNormalAirRaidMode(): boolean {
      return this.airbaseInfo.isDefense && this.battleInfo.airRaidFleet.cellType !== CELL_TYPE.SUPER_HIGH_AIR_RAID;
    },
  },
  methods: {
    setInfo() {
      this.$emit('input', new AirbaseInfo({ info: this.airbaseInfo }));
    },
    async showItemList(index: number, slot: number) {
      this.dialogTarget = [index, slot];
      const base = this.airbaseInfo.airbases[index];
      await (this.itemListDialog = true);
      (this.$refs.itemList as InstanceType<typeof ItemList>).initialFilter(base);
    },
    equipItem(argItem: Item) {
      const item = argItem.data;
      const index = this.dialogTarget[0];
      const slot = this.dialogTarget[1];
      const base = this.airbaseInfo.airbases[index];

      if (!base) {
        return;
      }

      const initialLevels = (this.$store.state.siteSetting as SiteSetting).planeInitialLevels;
      if (slot < base.items.length) {
        // インスタンス化用のいろいろ用意
        let initialSlot = 18;
        let initialLevel = 0;

        if (Const.RECONNAISSANCES.includes(item.apiTypeId)) {
          // 偵察機の場合、搭載数関係はすべて4機制限
          initialSlot = 4;
        } else if (Const.AB_ATTACKERS_LARGE.includes(item.apiTypeId)) {
          // 大型陸上機は9機
          initialSlot = 9;
        }
        if (initialLevels) {
          // 設定情報より初期熟練度を解決
          const initData = initialLevels.find((v) => v.id === item.apiTypeId);
          if (initData) {
            initialLevel = initData.level;
          }

          if (item.id === 312 && initialLevel > 25) {
            // 陸上偵察機(熟練)の制御
            initialLevel = 25;
          } else if (item.id === 311) {
            // 陸上偵察機無印の制御
            initialLevel = 0;
          }
        }

        const builder: ItemBuilder = {
          master: item,
          slot: initialSlot,
          level: initialLevel,
          remodel: argItem.remodel,
        };
        base.items[slot] = new Item(builder);
        this.itemListDialog = false;
      }

      const builder: AirbaseBuilder = { airbase: base };
      if (base.mode === AB_MODE.WAIT && base.items.some((v) => v.data.id > 0 && v.fullSlot > 0)) {
        // 待機札だった場合は出撃か防空札に変更
        builder.mode = this.airbaseInfo.isDefense ? AB_MODE.DEFENSE : AB_MODE.BATTLE;
        // 派遣先を最終戦闘にオート設定
        const lastBattle = this.battleInfo.battleCount - 1;
        builder.battleTarget = [lastBattle, lastBattle];
      }
      // リアクティブ再登録
      this.airbaseInfo.airbases[index] = new Airbase(builder);
      this.setInfo();
    },
    supply() {
      const targets = this.bulkUpdateTarget.concat();
      this.bulkUpdateTarget = [1, 1, 1];

      this.bulkUpdateAllItem({ slot: 99 });
      this.setInfo();

      this.bulkUpdateTarget = targets;
    },
    doAirRaid() {
      const { airbases } = this.airbaseInfo;
      for (let i = 0; i < airbases.length; i += 1) {
        if (airbases[i].mode === AB_MODE.WAIT) {
          continue;
        }

        let count = 4;
        const { items } = airbases[i];
        for (let j = 0; j < items.length; j += 1) {
          const item = items[j];
          if (item.fullSlot <= 1) {
            continue;
          }
          if (item.fullSlot > count) {
            items[j] = new Item({ item, slot: item.fullSlot - count });
            break;
          } else {
            items[j] = new Item({ item, slot: 1 });
            count -= item.fullSlot - 1;
          }
        }
        airbases[i] = new Airbase({ airbase: airbases[i], items });
      }
      this.setInfo();
    },
    resetAirbaseAll() {
      this.$emit('input', new AirbaseInfo());
    },
    toggleTargetDialog() {
      if (!this.targetDialog) {
        this.setInfo();
      }
    },
    closeTargetDialog() {
      this.targetDialog = false;
      this.setInfo();
    },
    closeItemList() {
      this.itemListDialog = false;
    },
    changeWidth(width: number) {
      this.itemDialogWidth = width;
    },
    captureAirbase() {
      // 背景色とかを塗るフラグ立て
      this.capturing = true;
      const div = document.getElementById('airbase-container') as HTMLDivElement;
      setTimeout(() => {
        html2canvas(div, { scale: 2 }).then((canvas) => {
          const link = document.createElement('a');
          link.href = canvas.toDataURL();
          link.download = `airbase_${Convert.formatDate(new Date(), 'yyyyMMdd-HHmmss')}.jpg`;
          link.click();
          this.capturing = false;
        });
      }, 10);
    },
    toggleBulkTarget() {
      if (this.bulkUpdateTarget.some((v) => !v)) {
        this.bulkUpdateTarget = [1, 1, 1];
      } else {
        this.bulkUpdateTarget = [0, 0, 0];
      }
    },
    getLevelValue(value: number) {
      return Const.PROF_LEVEL_BORDER[value];
    },
    setLevel(index: number) {
      this.bulkUpdateAllItem({ level: Const.PROF_LEVEL_BORDER[index] });
    },
    setRemodel(remodel: number) {
      this.bulkUpdateAllItem({ remodel });
    },
    resetSlot() {
      this.setSlot(18);
    },
    setSlot(value: number) {
      this.bulkUpdateSlotValue = value;
      this.bulkUpdateSlot();
    },
    bulkUpdateSlot() {
      this.bulkUpdateAllItem({ slot: this.bulkUpdateSlotValue });
    },
    setMaxLevelOnlyFighter() {
      this.bulkUpdateAllItem({ level: 120 }, true);
    },
    bulkUpdateAllItem(itemBuilder: ItemBuilder, onlyFighter = false) {
      // 指定ビルダーで装備情報一括更新
      const { airbases } = this.airbaseInfo;
      for (let i = 0; i < airbases.length; i += 1) {
        if (!this.bulkUpdateTarget[i]) {
          continue;
        }
        const { items } = airbases[i];
        for (let j = 0; j < items.length; j += 1) {
          const item = items[j];
          if (!onlyFighter || (onlyFighter && item.data.isFighter)) {
            let { slot } = item;
            if (item.data.isRecon && itemBuilder.slot !== undefined) {
              slot = Math.min(4, itemBuilder.slot);
            } else if (item.data.isShinzan && itemBuilder.slot !== undefined) {
              slot = Math.min(9, itemBuilder.slot);
            } else if (item.data.isPlane && itemBuilder.slot !== undefined) {
              slot = Math.min(18, itemBuilder.slot);
            }
            items[j] = new Item({
              item,
              slot,
              remodel: item.data.canRemodel ? itemBuilder.remodel : undefined,
              level: itemBuilder.level,
            });
          }
        }
        airbases[i] = new Airbase({ airbase: airbases[i] });
      }

      const newInfo = new AirbaseInfo({ info: this.airbaseInfo });
      newInfo.calculated = true;
      this.$emit('input', newInfo);
    },
    closeBulkUpdateDialog() {
      this.bulkUpdateDialog = false;
      this.onBulkUpdateDialogToggle();
    },
    onBulkUpdateDialogToggle() {
      if (!this.bulkUpdateDialog) {
        if (this.bulkUpdateSlotValue && this.bulkUpdateSlotChanged) {
          this.bulkUpdateSlot();
        }
        this.setInfo();
      }

      this.bulkUpdateSlotChanged = false;
    },
    showItemPresets(baseIndex: number) {
      const airbase = this.airbaseInfo.airbases[baseIndex];
      this.dialogTarget = [baseIndex, 0];
      this.tempAirbase = airbase;
      this.itemPresetDialog = true;
    },
    expandItemPreset(preset: ItemPreset) {
      const itemMasters = this.$store.state.items as ItemMaster[];
      const items: Item[] = [];
      for (let i = 0; i < preset.items.length; i += 1) {
        const item = itemMasters.find((v) => v.id === preset.items[i].id);
        if (item) {
          items.push(new Item({ master: item, remodel: preset.items[i].remodel }));
        } else {
          items.push(new Item());
        }
      }
      const index = this.dialogTarget[0];
      const airbase = this.airbaseInfo.airbases[index];
      // もともとここに配備されていた装備情報を抜き取る
      const newItems = airbase.items.concat();
      // 装備搭載可否情報マスタ
      for (let slotIndex = 0; slotIndex < airbase.items.length; slotIndex += 1) {
        if (slotIndex < items.length) {
          const newItem = items[slotIndex];
          if (newItem && Const.PLANE_TYPES.includes(newItem.data.apiTypeId)) {
            // マスタ情報があり、装備条件を満たしている場合は装備引継ぎOK！
            let slot = 18;
            if (Const.RECONNAISSANCES.includes(newItem.data.apiTypeId)) {
              slot = 4;
            } else if (Const.AB_ATTACKERS_LARGE.includes(newItem.data.apiTypeId)) {
              slot = 9;
            }

            // 初期熟練度設定
            const initialLevels = (this.$store.state.siteSetting as SiteSetting).planeInitialLevels;
            let level = 0;
            if (initialLevels) {
              // 設定情報より初期熟練度を解決
              const initData = initialLevels.find((v) => v.id === newItem.data.apiTypeId);
              if (initData) {
                level = initData.level;
              }

              if (newItem.data.id === 312 && level > 25) {
                // 陸上偵察機(熟練)の制御
                level = 25;
              } else if (newItem.data.id === 311) {
                // 陸上偵察機無印の制御
                level = 0;
              }
            }
            newItems[slotIndex] = new Item({
              master: newItem.data,
              item: newItems[slotIndex],
              slot,
              level,
              remodel: newItem.remodel,
            });
          } else {
            // 不適合、外す
            newItems[slotIndex] = new Item();
          }
        }
      }

      // 再インスタンス化し更新
      this.airbaseInfo.airbases[index] = new Airbase({ airbase, items: newItems });
      const newInfo = new AirbaseInfo({ info: this.airbaseInfo });
      this.$emit('input', newInfo);
    },
    closeItemPreset() {
      this.itemPresetDialog = false;
    },
  },
});
